import { useContext } from "react"
import StateOfRegulationsTreeContext from "../context/StateOfRegulationsTreeContext"

const useStateOfRegulationsTree = () => {
    return useContext(StateOfRegulationsTreeContext);
}

export default useStateOfRegulationsTree